import { createContext } from 'react';

const domainState = { domain: undefined, setDomain: undefined }

export const DomainContext = createContext(domainState);